import Typography from '@mui/material/Typography';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import type { BankWireResultInfo, EnvoyBankInfo } from '../../../../../../../../types/Cashier';

import {
  TXTWCL_Account_NoX_XbXN0X_bX,
  TXTWCL_Bank_nameX_XbXN0X_bX,
  TXTWCL_BeneficiaryX_XbXN0X_bX,
  TXTWCL_CityX_XbXN0X_bX,
  TXTWCL_CountryX_XbXN0X_bX,
  TXTWCL_IBANX_XbXN0X_bX,
  TXTWCL_One_time_reference_numberX_XbX_ELL,
  TXTWCL_SWIFTX_XbXN0X_bX,
  TXTWCL_Special_IDX_XbXN0X_bX
} from './BankInfo.messages.json';
import { info } from './BankInfo.scss';

interface Props {
  bankInfo?: Partial<EnvoyBankInfo> & Partial<BankWireResultInfo>;
  uniqueRefId?: string;
}

const BankInfo: React.FC<Props> = ({ bankInfo, uniqueRefId }) => {
  const {
    paymentReference,
    name,
    bankName,
    accountNum,
    bankAcct,
    iban,
    swift,
    beneficiary,
    accountHolder,
    specialId,
    city,
    country
  } = bankInfo || {};

  return (
    <Typography component="div" classes={{ root: info }}>
      <Translation
        tagName="p"
        {...TXTWCL_One_time_reference_numberX_XbX_ELL}
        values={{ 0: uniqueRefId || paymentReference }}
      />

      <Translation tagName="p" {...TXTWCL_Bank_nameX_XbXN0X_bX} values={{ 0: name || bankName }} />

      <Translation
        tagName="p"
        {...TXTWCL_Account_NoX_XbXN0X_bX}
        values={{ 0: accountNum || bankAcct }}
      />

      {iban && <Translation tagName="p" {...TXTWCL_IBANX_XbXN0X_bX} values={{ 0: iban }} />}

      <Translation tagName="p" {...TXTWCL_SWIFTX_XbXN0X_bX} values={{ 0: swift }} />

      {specialId && (
        <Translation tagName="p" {...TXTWCL_Special_IDX_XbXN0X_bX} values={{ 0: specialId }} />
      )}

      <Translation
        tagName="p"
        {...TXTWCL_BeneficiaryX_XbXN0X_bX}
        values={{ 0: beneficiary || accountHolder }}
      />

      {city && <Translation tagName="p" {...TXTWCL_CityX_XbXN0X_bX} values={{ 0: city }} />}

      {country && (
        <Translation tagName="p" {...TXTWCL_CountryX_XbXN0X_bX} values={{ 0: country }} />
      )}
    </Typography>
  );
};
export default BankInfo;
